const UPDATE = 'SELF_USER_UPDATE'

function update(obj) {
  return {
    type: UPDATE,
    payload: obj
  }
}

module.exports = {
  UPDATE,
  update
}
